import ApiClient from "../helpers/ApiClient";

export const createGalleryAlbum = async ({ album_name }) => {
    try {
        const response = await ApiClient.post(`/AlumniPage/addAlbum`, { album_name });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getGalleryAlbumData = async () => {
    try {
        const response = await ApiClient.get(`/AlumniPage/getAlbum`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addImageData = async ({ album_id, file }) => {
    try {
        const response = await ApiClient.post(`/AlumniPage/addImages`,
            {  album_id, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteImageData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/AlumniPage/deleteImages/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteAlbumData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/AlumniPage/deleteAlbum/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}